<h1 mat-dialog-title>Create output formula &mdash; EV</h1>
<mat-dialog-content class="dialog-body">
  <mat-form-field appearance="outline" class="form-field">
    <mat-label>Name</mat-label>
    <input matInput [formControl]="nameControl" type="text" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-field">
    <mat-label>EV conventions</mat-label>
    <mat-select [formControl]="evConventionIdsControl" multiple>
      @for (fc of evConventions; track fc.id) {
        <mat-option [value]="fc.id">{{ fc.name }}</mat-option>
      }
    </mat-select>
    @if (evConventions.length === 0) {
      <mat-hint>No EV conventions exist yet. Create one in the Filename conventions tab first.</mat-hint>
    }
  </mat-form-field>

  <div class="section-header">
    <h3 class="section-title">Media specs</h3>
  </div>

  <div class="spawn-buttons">
    <button
      mat-stroked-button
      type="button"
      [disabled]="stillsSectionOpen || !stillsAvailable"
      (click)="addStillsSection()"
    >
      <mat-icon inline="true">image</mat-icon>+ Stills spec
    </button>
    <button
      mat-stroked-button
      type="button"
      [disabled]="videosSectionOpen || !videosAvailable"
      (click)="addVideosSection()"
    >
      <mat-icon inline="true">movie</mat-icon>+ Videos spec
    </button>
  </div>

  @if (stillsSectionOpen) {
    <div class="media-section">
      <div class="media-section-header">
        <span class="media-section-title">
          <mat-icon inline="true">image</mat-icon>Stills spec
        </span>
        <button
          mat-icon-button
          type="button"
          title="Remove stills spec"
          (click)="removeStillsSection()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Spec</mat-label>
        <mat-select [formControl]="stillsSpecIdControl">
          @for (fs of stillsFileSpecifications; track fs.id) {
            <mat-option [value]="fs.id">{{ fs.name }}</mat-option>
          }
        </mat-select>
        @if (stillsFileSpecifications.length === 0) {
          <mat-hint>No stills specs exist yet. Create one in the File specifications tab first.</mat-hint>
        }
      </mat-form-field>
    </div>
  }

  @if (videosSectionOpen) {
    <div class="media-section">
      <div class="media-section-header">
        <span class="media-section-title">
          <mat-icon inline="true">movie</mat-icon>Videos spec
        </span>
        <button
          mat-icon-button
          type="button"
          title="Remove videos spec"
          (click)="removeVideosSection()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Spec</mat-label>
        <mat-select [formControl]="videosSpecIdControl">
          @for (fs of videosFileSpecifications; track fs.id) {
            <mat-option [value]="fs.id">{{ fs.name }}</mat-option>
          }
        </mat-select>
        @if (videosFileSpecifications.length === 0) {
          <mat-hint>No videos specs exist yet. Create one in the File specifications tab first.</mat-hint>
        }
      </mat-form-field>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="buttonSuccess"
    [disabled]="!canCreate"
    (click)="create()"
  >
    Create
  </button>
</mat-dialog-actions>
